export default "__VITE_ASSET__C$yXNWxR__"